<script lang="ts">
    import { tgettext } from 'hydria/services/gettext'

    import SimpleListingWithPagination from 'hydria/components/SimpleListings/SimpleListingWithPagination.svelte'

    const singular = 'help'
    const plural = 'helps'
    const baseUrl = '/helps'

    const pageTitle = tgettext('Textes d’aide')
    const createButtonText = tgettext('Ajouter un texte d’aide')
    interface Props {
        route: any
    }

    let { route }: Props = $props()
</script>

<SimpleListingWithPagination {route} {singular} {plural} {baseUrl} {pageTitle} {createButtonText} />
